import * as React from 'react';

const IconAlarmClockTime = props => (
  <svg
    width="1em"
    height="1em"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m14.742 15.313 1.926 1.927M5.254 15.314 3.328 17.24"
      stroke="currentColor"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx={9.998}
      cy={10.625}
      r={6.669}
      stroke="currentColor"
      strokeWidth={1.25}
    />
    <path
      d="M9.775 7.464v3.662l2.879 1.755"
      stroke="currentColor"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M5.414 2.705a2.931 2.931 0 0 1 2.584 1.56 6.575 6.575 0 0 0-2.717 1.641 6.766 6.766 0 0 0-1.443 2.16 2.883 2.883 0 0 1-1.342-2.443 2.921 2.921 0 0 1 2.918-2.918ZM14.584 2.705a2.921 2.921 0 0 1 2.918 2.918 2.883 2.883 0 0 1-1.342 2.443 6.766 6.766 0 0 0-1.442-2.16A6.575 6.575 0 0 0 12 4.264a2.931 2.931 0 0 1 2.584-1.559Z"
      stroke="currentColor"
      strokeWidth={1.25}
    />
  </svg>
);

export default IconAlarmClockTime;
